import { render, staticRenderFns } from "./Tagfamilies.vue?vue&type=template&id=262f5f1a"
import script from "./Tagfamilies.vue?vue&type=script&lang=js"
export * from "./Tagfamilies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports